<section id="content" *ngIf="this.lang">
  <div class="page page-profile">

    <!-- page header -->
    <div class="pageheader">
      <h2>{{lang.servicing}} {{ lang.view }}</h2>
      <div class="page-bar">
        <ul class="page-breadcrumb">
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.DASHBOARD"><i class="fa fa-home"></i>
              {{AppSettings.SITE_TITLE | titlecase}}</a>
          </li>
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.Servicing_List">{{lang.servicing}}</a>
          </li>
          <li>
            <span *ngIf="single_data">{{ single_data?.service_no_plate }} / {{ single_data?.service_disp }}</span>
          </li>

        </ul>

        <div style="float: right;">
          <div class="social-icons">
            <a class="plus-vdead" (click)="viewServicing()"
              [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
              <i class="fa fa-list"></i>
            </a>

            <a class="plus-edit" (click)="editServicing(this.id)"
              [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
              <i class="fa fa-edit"></i>
            </a>
          </div>
        </div>

      </div>
    </div>
    <!-- page content -->
    <div class="pagecontent">

      <!-- row -->
      <div class="row">
        <div class="col-md-12">
          <div class="tile tile-simple">

            <!-- tile body -->
            <div class="tile-body" [ngSwitch]="pageView">
              <div role="tabpanel" *ngSwitchCase="'list'">

                <!-- Nav tabs -->
                <ul class="nav nav-tabs tabs-dark" role="tablist">
                  <li role="presentation" [ngClass]="selectedTab === 'general' ? 'active' : 'none'"><a
                      href="#generalTab" aria-controls="feedTab" role="tab" data-toggle="tab">{{ lang.generalData }}</a>
                  </li>


                  <li role="presentation" [ngClass]="selectedTab === 'documents' ? 'active' : 'none'"><a
                      href="#documents" aria-controls="documents" role="tab" data-toggle="tab">{{ lang.documents }}</a></li>

                  <li role="presentation" [ngClass]="selectedTab === 'ord' ? 'active' : 'none'"><a
                      href="#ordinarymaintenanceTab" aria-controls="ordinarymaintenanceTab" role="tab"
                      data-toggle="tab">{{ lang.ordinaryData}}</a>
                  </li>

                  <li role="presentation" [ngClass]="selectedTab === 'exord' ? 'active' : 'none'"><a
                      href="#extraordinarymaintenanceTab" aria-controls="extraordinarymaintenanceTab" role="tab"
                      data-toggle="tab">{{ lang.extraordinaryData
                      }}</a></li>


                  <li role="presentation"><a href="#statistics" aria-controls="statistics" role="tab"
                      data-toggle="tab">{{ lang.statistics }}</a></li>


                </ul>

                <!-- <div class="social-icons">

                  <a class="plus-add" (click)="addServicing()">
                  <i class="fa fa-plus"></i>
                </a>
                </div> -->

                <div class="tab-content">

                  <div role="tabpanel" class="tab-pane" [ngClass]="selectedTab === 'general' ? 'active' : 'none'"
                    id="generalTab">
                    <div class="wrap-reset">

                      <form [formGroup]="generalsForm" class="form-validation">

                        <div class="row">
                          <div class="form-group col-sm-6">


                            <div class="col-md-12">
                              <div class="col-md-3">
                                <img src="{{single_data?.simage}}"
                                  style="width: 100%;
                                    background-color: #f5f5f5;border: 1px solid #ddd; border-radius: 4px;display: block; line-height: 1.42857; margin-bottom: 20px; padding: 4px;transition: all 0.2s ease-in-out 0s;">
                              </div>

                              <div class="col-sm-9">
                                <div class="col-sm-5 for_label">{{ lang.type }}:</div>
                                <div class="col-sm-7 for_label_value">{{single_data?.service_type}}</div>

                                <div class="col-sm-5 for_label">{{ lang.description }}:</div>
                                <div class="col-sm-7 for_label_value">{{single_data?.service_disp}}</div>

                                <div class="col-sm-5 for_label">{{ lang.brand }}:</div>
                                <div class="col-sm-7 for_label_value">{{single_data?.service_brand}}</div>

                                <div class="col-sm-5 for_label">{{ lang.model }}:</div>
                                <div class="col-sm-7 for_label_value">{{single_data?.service_model}}</div>
                              </div>
                            </div>


                            <div class="col-md-12">
                                <div class="col-md-6" id="QR_div" style="width:180px; background-color:white; text-align:center; padding:10px;" *ngIf="imgQR">
                                  <img width="100%" style="cursor:pointer;" src="http://vmi313621.contaboserver.net/Software_demo/assets/images/QR_CODE_ICON.png" class="image-responsive " (click)="pdfDownload(imgQR, 'KaizenCloud_qrcode.jpg')">
                                  <!-- <p style="text-align:center; margin:0;">
                                    {{ lang.brand }}: {{single_data?.service_brand}}<br>
                                    {{ lang.model }}: {{single_data?.service_model}}<br>
                                    {{ lang.factoryNumber }}: {{single_data?.service_fact}}
                                  </p> -->
                                </div>

                                <div id="save_pdf" class="col-md-6" style="width:180px; background-color:white; text-align:center; padding:10px;" >
                                    <img width="100%" style="cursor:pointer;" (click)="convertToPDF(this.id)" class="image-responsive " src="http://vmi313621.contaboserver.net/Software_demo/assets/images/pdf-download.png" width="100%"
                                    height="100%" (click)="downloadQR('KaizenCloud_qrcode.png')">
                                </div>
                            </div>


                            <!-- <div class="col-sm-9">
                              <button class="btn btn-primary" (click)="pdfDownload(imgQR, 'KaizenCloud_qrcode.jpg')"
                                style="margin-left: 25px; border-radius: 7px;"><i class="fa fa-download fa-fw">
                                </i>Save</button>
                            </div>  -->

                            <!-- <div id="QR_div"
                              style="width:180px; background-color:white; text-align:center; padding:10px;"
                              *ngIf="imgQR" #screen>
                              <img width="100%" src="{{imgQR}}" class="image-responsive ">
                              <p style="text-align:center; margin:0;">
                                {{ lang.brand }}: {{single_data?.service_brand}}<br>
                                {{ lang.model }}: {{single_data?.service_model}}<br>
                                {{ lang.factoryNumber }}: {{single_data?.service_fact}}
                              </p>
                            </div> -->
                            <!-- <div class="col-sm-9 martop-20">
                              <button class="btn btn-primary" (click)="downloadQR('KaizenCloud_qrcode.png')"
                                style="margin-left: 25px; border-radius: 7px;"><i class="fa fa-download fa-fw">
                                </i>Downloads</button>
                            </div>  -->

                          </div>

                          <!-- <a id="imgQRD" href="" download="KaizenCloud_qrcode.jpg"></a> -->




                          <div class="form-group col-sm-6">
                            <div class="form-group col-sm-12">
                              <div class="form-group col-sm-3">

                                <label for="badge-number">{{ lang.matricolaNumberPlate }}</label>
                              </div>
                              <div class="form-group col-sm-9">
                                <input type="text" class="form-control" formControlName="service_no_plate" readonly>
                              </div>
                            </div>

                            <div class="form-group col-sm-12">
                              <div class="form-group col-sm-3">
                                <label for="factory-number">{{ lang.factoryNumber }}</label>
                              </div>
                              <div class="form-group col-sm-9">
                                <input type="text" class="form-control" formControlName="service_fact" readonly>
                              </div>
                            </div>

                            <div class="form-group col-sm-12">
                              <div class="form-group col-sm-3">
                                <label for="date-of-commissioning">{{ lang.dateofCommissioning }}</label>
                              </div>
                              <div class="form-group col-sm-9">
                                <input type="text" class="form-control" formControlName="service_doc" readonly>
                              </div>
                            </div>

                            <div class="form-group col-sm-12">
                              <div class="form-group col-sm-3">
                                <label for="place-of-use">{{ lang.location }}</label>
                              </div>
                              <div class="form-group col-sm-9">
                                <input type="text" class="form-control" formControlName="service_location" readonly>
                              </div>
                            </div>

                            <div class="form-group col-sm-12">
                              <div class="form-group col-sm-3">
                                <label for="state">{{ lang.status }}</label>

                              </div>
                              <div class="form-group col-sm-9">
                                <input type="text" class="form-control" formControlName="service_recpon" readonly>
                              </div>
                            </div>


                            <div class="form-group col-sm-12">
                              <div class="form-group col-sm-3">
                                <label for="responsible">{{ lang.responsible }}</label>
                              </div>
                              <div class="form-group col-sm-9">
                                <input type="text" class="form-control" formControlName="responsible" readonly>
                              </div>
                            </div>


                            <!-- <div class="form-group col-sm-12">
                              <div class="form-group col-sm-3">
                                <label for="attachments">{{ lang.attachments }}</label>
                              </div>
                              <div class="form-group col-sm-9">
                                <input type="text" class="form-control" formControlName="service_attach" readonly>
                              </div>
                            </div> -->
                          </div>

                        </div>
                      </form>
                    </div>

                    <div class="form-group" style="overflow: auto;">
                      <table datatable [dtOptions]="datatableOptns" class="table-striped table-sm row-border hover"
                        style="width: 100%" id="generaltable" *ngIf="plans">
                        <thead>
                          <tr>
                            <th>{{ lang.sno }}</th>
                            <th>{{ lang.planCode }}</th>
                            <th>{{ lang.description }}</th>
                            <th>{{ lang.repetitions }}</th>
                            <th>{{ lang.daysnotify }}</th>
                            <th>{{ lang.notification_time }}</th>
                            <th>{{ lang.planStartingdate }}</th>
                            <th>{{ lang.action }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let record of plans let i = index">
                            <td>{{ i + 1 }}</td>
                            <td>{{ record.plan_code }}</td>
                            <td>{{ record.plan_description }}</td>
                            <td>{{ record.how_often_value }} {{ record.how_often_frequency }}</td>
                            <td>{{ record.days_notify }}</td>
                            <td>{{ record.notification_time}}</td>
                            <td>{{ record.date }}</td>
                            <td>
                              <div *ngIf="record.date; then thenBlock else elseBlock"></div>
                              <ng-template #thenBlock><button
                                  (click)="turnoff(record.sId,record.pk_maintenance_plan_id,record.rid)"
                                  class="btn btn-danger" style="border-radius: 7px;"
                                  [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">{{
                                  lang.deactivatePlan }}</button>
                              </ng-template>
                              <ng-template #elseBlock>
                                <button (click)="activate_plan(record.pk_maintenance_plan_id, record.sId)"
                                  class="btn btn-success" style="border-radius: 7px;"
                                  [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">{{
                                  lang.activatePlan }}</button>
                              </ng-template>
                            </td>

                          </tr>
                        </tbody>

                      </table>
                    </div>
                  </div>

                  <div role="tabpanel" class="tab-pane" [ngClass]="selectedTab === 'ord' ? 'active' : 'none'"
                    id="ordinarymaintenanceTab">

                    <accordion [isAnimated]="true" [closeOthers]="true">

                      <accordion-group [isOpen]="open" *ngFor="let pvdata of planvals let i = index"
                        heading="{{lang?.planCode}} : {{ pvdata.plan_code }}      {{lang?.plan_desc}} : {{ pvdata.plan_description}}    {{lang?.repetitions}} : {{ pvdata.how_often_value }}"
                        class="accordion{{ i + 1 }}" class="arrow down">

                        <input type="hidden" name="odval" class="odval{{ i + 1 }}" value="{{cnt }}">

                        <div class="row p-10">
                          <div class="col-sm-9">

                            <div class="social-icons">
                              <a class="plus-export omplan{{ i + 1 }}" data-toggle="modal"
                                (click)="odatatableExport(i+1)" data-options="splash-2 splash-ef-4" title="Export">
                                <span class="glyphicon glyphicon-export"></span>
                              </a>



                              <a class="plus-copy" (click)="multiOrdDuplicate(i+1)" data-action="show" data-id=""
                                [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Duplicate">
                                <span class="glyphicon glyphicon-file"></span>
                              </a>

                              <a class="plus-delete odplus_del{{ i + 1 }}" (click)="deleteMultiOrdinary(i+1)"
                                style="display: none;"
                                [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Erase">
                                <span class="glyphicon glyphicon-trash"></span>
                              </a>
                              <input type="hidden" id="dmulval" class="dmulval" value="">

                            </div>
                          </div>

                          <div class="col-sm-3" style="float: right;">
                            <div class="">
                              <a class="plus-add" (click)="add_ordinary(this.id,pvdata.plan_id)"
                                [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                                <button class="btn btn-success"><i class="fa fa-plus"></i> {{
                                  odlang?.insertOrdinaryMaintenance }}</button>
                              </a>
                            </div>
                          </div>
                        </div>

                        <div class="form-group" style="overflow: auto;">
                          <table datatable [dtOptions]="datatableOptions3"
                            class="table-striped table-sm row-border hover otable{{ i + 1 }}">
                            <thead>
                              <tr>
                                <th>Hidden.No</th>
                                <th>
                                  <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                                    <input type="checkbox" [(checked)]="checked" class="chk{{ i + 1 }}"
                                      value="{{ cnt }}"><i></i>
                                  </label>
                                </th>
                                <th>{{ odlang?.sno }}</th>
                                <th>{{ odlang?.executionDate }}</th>
                                <th>{{ odlang?.description }}</th>
                                <th>{{ odlang?.performer }}</th>
                                <th>{{ odlang?.outcome }}</th>
                                <th>{{ odlang?.notes }}</th>
                                <th>{{ odlang?.option }}</th>
                                <th>{{ odlang?.nextintervention }}</th>
                                <th>{{ odlang?.referringDate }}</th>
                                <th>{{ odlang?.cost }}</th>
                                <th>{{ odlang?.attachments }}</th>
                                <th>{{ odlang?.action }}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let odata of pvdata.ordata let k = index" id="{{odata.ordinaryId}}"
                                [style.color]="odata.color">
                                <td>{{k+1}}</td>
                                <td (click)="onchk(odata.ordinaryId,i + 1)"></td>
                                <td>{{k+1}}</td>
                                <td>{{ odata.execution_date }}</td>
                                <td>{{ odata.discription }}</td>
                                <td>{{ odata.performer }}</td>
                                <td>{{ odata.outcome }}</td>
                                <td>{{ odata.notes}}</td>
                                <td>{{ odata.change_deadline }}</td>
                                <td>{{ odata.new_deadline }}</td>
                                <td>{{ odata.refering_date }}</td>
                                <td>{{ odata.cost }}</td>
                                <td>{{ odata.file_name }}</td>
                                <td>
                                  <div class="btn-group dropup">

                                    <button type="button" class="btn btn-info dropdown-toggle circle_btn"
                                      data-toggle="dropdown" aria-expanded="false"><i class="fa fa-tasks"></i></button>

                                    <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                                      <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                          class="edit_action"
                                          (click)="edit_ordinary(odata.ordinaryId,this.id,odata.pk_maintenance_plan_id)"><i
                                            class="fa fa-edit"></i>{{ odlang?.modify }}</a></li>
                                      <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                          class="view_action"
                                          (click)="duplicate_ordinary(odata.ordinaryId,this.id,odata.pk_maintenance_plan_id)"><i
                                            class="fa fa-clipboard"></i>{{ odlang?.duplicate }}</a></li>
                                      <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                          class="delete_action" (click)="delete_ordinary(odata.ordinaryId)"><i
                                            class="fa fa-trash"></i>{{ odlang?.erase }}</a></li>

                                    </ul>
                                  </div>
                                </td>
                              </tr>


                            </tbody>

                          </table>
                        </div>
                      </accordion-group>



                    </accordion>

                  </div>

                  <div role="tabpanel" class="tab-pane" [ngClass]="selectedTab === 'exord' ? 'active' : 'none'"
                    id="extraordinarymaintenanceTab">

                    <div class="row p-10">
                      <div class="col-sm-9">

                        <div class="social-icons">
                          <!-- <a class="plus-export" data-toggle="modal" data-target="#datatableExport2"
                            data-options="splash-2 splash-ef-4">
                            <span class="glyphicon glyphicon-export"></span>
                          </a> -->

                          <a class="plus-export" data-toggle="modal" data-target="#datatableExport2"
                            data-options="splash-2 splash-ef-4" title="Export">
                            <span class="glyphicon glyphicon-export"></span>
                          </a>
                          <!-- 
                          <a class="plus-vdead" (click)="viewServicing()">
                            <i class="fa fa-list"></i>
                          </a>


                          <a class="plus-edit" (click)="editServicing(this.id)">
                            <i class="fa fa-edit"></i>
                          </a> -->



                          <a class="plus-copy" (click)="multiDuplicate()" data-action="show" data-id=""
                            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Duplicate">
                            <span class="glyphicon glyphicon-file"></span>
                          </a>

                          <a class="plus-delete" *ngIf="deleteOption" (click)="multiDelete1()"
                            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Erase">
                            <span class="glyphicon glyphicon-trash"></span>
                          </a>


                        </div>

                      </div>

                      <div class="col-sm-3" style="float: right;">
                        <div class="">
                          <a class="plus-add" (click)="add_extraordinary(this.id)"
                            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                            <button class="btn btn-success"><i class="fa fa-plus"></i> {{ exodlang?.enter }} {{
                              exodlang?.extraordinaryMaintenance }} </button>
                          </a>
                        </div>
                      </div>


                    </div>

                    <div class="form-group" style="overflow: auto;">
                      <table datatable [dtOptions]="datatableOptions2" class="table-striped table-sm row-border hover"
                        id="table2" *ngIf="exordinary_data">
                        <thead>
                          <tr>
                            <th>Hidden.No</th>
                            <th>
                              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                                <input type="checkbox"><i></i>
                              </label>
                            </th>
                            <th>{{ exodlang?.sno }}</th>
                            <th>{{ exodlang?.dateofIntervention }}</th>
                            <th>{{ exodlang?.description }}</th>
                            <th>{{ exodlang?.performer }}</th>
                            <th>{{ exodlang?.outcome }}</th>
                            <th>{{ exodlang?.notes }}</th>
                            <th>{{ exodlang?.cost }}</th>
                            <th>{{ exodlang?.links }}</th>
                            <th>{{ exodlang?.action }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let edata of exordinary_data let i = index"
                            id="{{edata.extraordinary_serviceId}}">
                            <td>{{i+1}}</td>
                            <td></td>
                            <td>{{i+1}}</td>
                            <td>{{ edata.date_of_intervention }}</td>
                            <td>{{ edata.description }}</td>
                            <td>{{ edata.performer }}</td>
                            <td>{{ edata.outcome }}</td>
                            <td>{{ edata.notes}}</td>
                            <td>{{ edata.cost }}</td>
                            <td>
                              <!-- {{ edata.ex_document_link | stringbreak }} -->
                              <div *ngFor='let document_link of edata.ex_document_link.split(",")'>
                                <a href="http://vmi313621.contaboserver.net/Software_backend/uploads/servicing/servicing_extraordinary/{{document_link}}"
                                  target="_blank">{{document_link}}</a>
                              </div>
                            </td>
                            <td>
                              <div class="btn-group dropup">

                                <button type="button" class="btn btn-info dropdown-toggle circle_btn"
                                  data-toggle="dropdown" aria-expanded="false"><i class="fa fa-tasks"></i></button>

                                <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                      class="delete_action"
                                      (click)="delete_extraordinary(edata.extraordinary_serviceId)"><i
                                        class="fa fa-trash"></i>{{ exodlang?.erase }}</a></li>
                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                      class="edit_action"
                                      (click)="edit_extraordinary(edata.extraordinary_serviceId,this.id)"><i
                                        class="fa fa-edit"></i>{{ exodlang?.modify }}</a></li>
                                </ul>
                              </div>
                            </td>
                          </tr>


                        </tbody>

                      </table>
                    </div>

                  </div>

                  <div role="tabpanel" class="tab-pane" [ngClass]="selectedTab === 'documents' ? 'active' : 'none'"
                    id="documents">

                    <div class="row p-10">
                      <div class="col-sm-9">

                        <div class="social-icons">

                          <a class="plus-add" (click)="add_sdocuments(this.id)"
                            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Add">
                            <i class="fa fa-plus"></i>
                          </a>


                          <a class="plus-export" data-toggle="modal" data-target="#datatableExport4"
                            data-options="splash-2 splash-ef-4" title="Export">
                            <span class="glyphicon glyphicon-export"></span>
                          </a>


                          <a class="plus-import" data-toggle="modal" data-target="#datatableImport4" data-action="show"
                            data-id="" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"
                            title="Import">
                            <span class="glyphicon glyphicon-import"></span>
                          </a>

                          <!-- 
                        <a class="plus-vdead" (click)="viewServicing()">
                          <i class="fa fa-list"></i>
                        </a>


                        <a class="plus-edit" (click)="editServicing(this.id)">
                          <i class="fa fa-edit"></i>
                        </a> -->



                          <a class="plus-copy" (click)="doc_multiDuplicate()" data-action="show" data-id=""
                            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Duplicate">
                            <span class="glyphicon glyphicon-file"></span>
                          </a>

                          <a class="plus-delete" *ngIf="deleteOption" (click)="doc_multiDelete()"
                            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Erase">
                            <span class="glyphicon glyphicon-trash"></span>
                          </a>


                        </div>

                      </div>

                    </div>


                    <div class="form-group" style="overflow: auto;">
                      <table datatable [dtOptions]="datatableOptions4" class="table-striped table-sm row-border hover"
                        id="table4" *ngIf="documents_data">
                        <thead>
                          <tr>
                            <th>Hidden.No</th>
                            <th>
                              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                                <input type="checkbox"><i></i>
                              </label>
                            </th>
                            <th>{{ doclang?.description }}</th>
                            <th>{{ doclang?.date }}</th>
                            <th>{{ doclang?.revision }}</th>
                            <th>{{ doclang?.attachments }}</th>
                            <th>{{ doclang?.status }}</th>
                            <th>{{ doclang?.action }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let doc_data of documents_data let i = index" id="{{doc_data.docId}}">
                            <td>{{i+1}}</td>
                            <td></td>
                            <td>{{ doc_data.description }}</td>
                            <td>{{ doc_data.date }}</td>
                            <td>{{ doc_data.revision }}</td>
                            <td><a href="{{ doc_data.attachment }}" target="_blank">{{ doc_data.attach }}</a></td>
                            <td>
                              <div *ngIf="doc_data.status == 1; then thenBlock else elseBlock"></div>
                              <ng-template #thenBlock>{{ doclang?.valid }}</ng-template>
                              <ng-template #elseBlock>{{ doclang?.passed }}</ng-template>
                            </td>
                            <td>
                              <div class="btn-group dropup">
                                <button type="button" class="btn btn-info dropdown-toggle circle_btn"
                                  data-toggle="dropdown" aria-expanded="false"><i class="fa fa-tasks"></i></button>

                                <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                      class="delete_action" (click)="delete_sdocuments(doc_data.docId)"><i
                                        class="fa fa-trash"></i>{{ doclang?.erase }}</a></li>
                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                      class="edit_action" (click)="edit_sdocuments(doc_data.docId,this.id)"><i
                                        class="fa fa-edit"></i>{{ doclang?.modify }}</a></li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                        </tbody>

                      </table>
                    </div>


                  </div>


                  <div role="tabpanel" class="tab-pane" [ngClass]="selectedTab === 'statistics' ? 'active' : 'none'"
                    id="statistics" style="height: 400px;">

                    <div class="row p-12">
                      <div class="col-sm-12">

                        <!--  <div class="social-icons col-sm-2">
                         <a class="plus-export" data-toggle="modal" data-target="#datatableExport4"
                            data-options="splash-2 splash-ef-4" title="Export">
                            <span class="glyphicon glyphicon-export"></span>
                          </a>
                        </div> -->

                        <div class="col-sm-3">
                          <input type="date" class="form-control" name="from_date" id="from_date"
                            (change)="search_date">
                        </div>
                        <div class="col-sm-3">
                          <input type="date" class="form-control" name="to_date" id="to_date" (change)="search_date">
                        </div>
                        <div class="col-sm-3">
                          <button (click)="myClickFunction($event)">{{lang?.search}}</button>
                        </div>

                      </div>

                    </div>
                    <br>

                     <div class="col-md-12" *ngIf="ord_data">  

                    <div id="chart-container" class="col-md-6" style="width: 50%;">
                      <canvas #myCanvas id="canvas" baseChart [chartType]="chartType" [datasets]="chartData"
                        [labels]="chartLabels" [colors]="chartColors" [options]="chartOptions" width="100%"></canvas>
                    </div>

                      <div style="display: block" class="col-md-6" style="width: 50%;">
                        <canvas baseChart [datasets]="barChartData" [labels]="barChartLabels"
                          [options]="barChartOptions" [legend]="barChartLegend" [chartType]="barChartType"
                          (chartHover)="chartHovered($event)" (chartClick)="chartClicked($event)"></canvas>
                      </div>
                    </div> 



                  </div>


                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</section>

<div class="modal splash fade" id="sactivate_plan" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ lang?.enterStartdate }}</h3>
      </div>

      <form #user="ngForm" (ngSubmit)="onSubmit(user.value)">
        <div class="modal-body column_export">
          <input type="date" class="form-control" name="date" id="date" value="" ngModel required>
          <input type="hidden" name="plan_id_forcd" id="plan_id_forcd" ngModel>
          <input type="hidden" name="pservice_id" id="pservice_id" ngModel>
        </div>

        <div class="modal-footer">
          <div id="datatableExportBtn1" class="export_dynamic_btn">
          </div>
          <button class="btn btn-success">{{ lang?.submit }}</button>
          <button class="btn btn-warning" data-dismiss="modal">{{ lang?.close }}</button>
        </div>
      </form>

    </div>
  </div>
</div>

<div class="modal splash fade" id="datatableExport2" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">Select Columns</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export2_select_deselect_all($event)"><i></i> Select All </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>Active Columns</h2>

            <div class="row" *ngFor="let option of datatableCols2">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export2_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn2" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>

<div class="modal splash fade" id="odatatableExport3" tabindex="-1" role="dialog" aria-hidden="true"
  style="display: none;">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ odlang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <input type="hidden" name="scol_val" class="scol_val" value="">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export3_select_deselect_all($event)"><i></i> {{ odlang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ odlang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols3">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export3_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn3" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ odlang?.close }}</button>
      </div>

    </div>
  </div>
</div>

<div class="modal splash fade" id="datatableExport4" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ doclang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export4_select_deselect_all($event)"><i></i> {{ doclang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ doclang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols4">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export3_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn4" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ doclang?.close }}</button>
      </div>

    </div>
  </div>
</div>
<div class="modal splash fade" id="datatableImport4" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- <div class="modal-header">
          <h3 class="modal-title custom-font">IMPORT HOURLY DATA</h3>
          <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span aria-hidden="true">&times;</span>
          </button>      
        </div>
         -->

      <div class="modal-header">
        <h4 class="modal-title pull-left" style="text-transform: uppercase;">{{ doclang?.dataImport }}</h4>
        <button type="button" class="close pull-right" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>


      <div class="modal-body column_export">
        <div class="row">
          <form>
            <input type="file" class="filestyle" id="file" name='file' data-buttonText="Choose file"
              (change)="onPhotoPickerChange($event)" appFileDesign>
            <font style="vertical-align: inherit;">
              <font style="vertical-align: inherit;"><a
                  href="http://vmi313621.contaboserver.net/Software_backend/uploads/documents.csv">{{
                  doclang?.downloadthecsvtemplate }}</a></font>
            </font>
          </form>
        </div>
      </div>

      <div class="modal-footer">
        <!-- <div id="datatableExportBtn2" class="export_dynamic_btn">
          </div> -->
        <button type="button" class="btn btn-primary" (click)="onclick()">{{ doclang?.save }}</button>
        <!-- <button class="btn btn-warning" data-dismiss="modal">Close</button>-->
        <button type="button" class="btn btn-warning" data-dismiss="modal">{{ doclang?.close }}</button>

      </div>
    </div>
  </div>
</div>
<!-- <script>
  alert('hai');
  anychart.onDocumentReady(function() {
      // create a pie chart
      var chart = anychart.pie([
          ["Chocolate", 5],
          ["Rhubarb compote", 2],
          ["Crêpe Suzette", 2],
          ["American blueberry", 2],
          ["Buttermilk", 1]
      ]);
      chart.title("Top 5 pancake fillings");
      // set the container where chart will be drawn
      chart.container("container");
      //  draw the chart on the page
      chart.draw();
  });
</script> -->